export const getUrlSearchParameters = () => {
    const hash = location.hash;
    let paramsString = '';
    if (hash.startsWith('#/')) {
        paramsString = hash.split('?')[1] || '';
    }
    else {
        paramsString = location.search;
    }
    return new URLSearchParams(paramsString);
};
//# sourceMappingURL=get-url-search-parameters.js.map